<template>
  <div class="kviz">
    <form
      action="#"
      @submit="formPost"
      method="post"
      novalidate="true"
      enctype="multipart/form-data"
      autocomplete="off"
      id="kvizmvuk"
    >
      <div
        v-for="(item, index) in kerdesek"
        v-bind:key="index"
        v-show="index + 1 === $store.state.currentStep"
        class="kerdesek"
      >
        <div
          v-if="item.bevezeto"
          class="kbevezeto"
        >
          {{item.bevezeto}}
        </div>
        <div class="kerdes">
          <span class="number">{{index+1}}.</span> {{item.kerdes}}
        </div>
        <div class="valaszcont">
          <div
            class="valasz"
            v-for="(valaszitem, index2) in valaszok"
            v-bind:key="index2"
          >
            <input
              type="radio"
              :name="'kerdes'+(index+1)"
              v-bind:value="index2"
              :id="'k'+(index+1)+'opt'+index2"
            >
            <label
              :for="'k'+(index+1)+'opt'+index2"
              v-on:click="choice"
            >
              {{valaszitem.text}}
            </label>
          </div>
        </div>
      </div>
      <div
        class="last"
        v-show="$store.state.currentStep === $store.state.maxStep"
      >
        <div class="urlaphead">
          <div class="title">
            Köszönjük, hogy kitöltötted tesztünket. Kérjük, add meg elérhetőségeid, és küldjük is az eredményt!
          </div>
        </div>
        <div class="formfield">
          <input
            v-model="nev"
            type="text"
            name="nev"
            id="nev"
            placeholder="név*"
          >
          <div
            v-if="errors.nev"
            class="error"
          >
            {{errors.nev}}
          </div>
        </div>
        <div class="formfield">
          <input
            v-model="email"
            type="email"
            name="email"
            id="email"
            placeholder="e-mail*"
          >
          <div
            v-if="errors.mail1"
            class="error"
          >
            {{errors.mail1}}
          </div>
          <div
            v-if="errors.mail2"
            class="error"
          >
            {{errors.mail2}}
          </div>
        </div>
        <div class="formfield">
          <vue-mask
            v-model="telefon"
            mask="99-99-999-9999"
            name="telefon"
            id="telefon"
            :raw="false"
            :options="teloptions"
          >
          </vue-mask>
          <div
            v-if="errors.telefon1"
            class="error"
          >
            {{errors.telefon1}}
          </div>
          <div
            v-if="errors.telefon2"
            class="error"
          >
            {{errors.telefon2}}
          </div>
        </div>
        <div class="formfield">
          <input
            v-model="beosztas"
            type="text"
            name="beosztas"
            id="beosztas"
            placeholder="beosztás*"
          >
          <div
            v-if="errors.beosztas"
            class="error"
          >
            {{errors.beosztas}}
          </div>
        </div>
        <div class="jogicont">
          <div class="magyarazat">
            A csillaggal jelölt mezők kitöltése kötelező.
          </div>
          <input
            type="checkbox"
            name="nyilatkozat"
            id="nyilatkozat"
            v-model="nyilatkozat"
          >
          <label
            for="nyilatkozat"
            class="nylabel"
          >
            <p><span
                v-if="errors.nyilatkozat"
                class="error"
              >{{errors.nyilatkozat}}</span> Az <a
                href="https://forbes.hu/documents/altalanos_adatkezelesi_tajekoztato_Forbeshu.pdf"
                target="_blank"
              >Adatkezelési Tájékoztatót</a> elolvastam és elfogadom.</p>
          </label>
          <!--<input
            type="checkbox"
            name="jatekszabaly"
            id="jatekszabaly"
            v-model="jatekszabaly"
          >
          <label
            for="jatekszabaly"
            class="jateklabel"
          >
            <p><span
                v-if="errors.jatekszabaly"
                class="error"
              >{{errors.jatekszabaly}}</span> A <a
                href="./Jatekszabalyzat-2019-MVUK.pdf"
                target="_blank"
              >játékszabályzatot</a> elolvastam és elfogadom.</p>
          </label>-->
          <input
            type="checkbox"
            name="eighteen"
            id="eighteen"
            v-model="eighteen"
          >
          <label
            for="eighteen"
            class="eighteenlabel"
          >
            <p><span
                v-if="errors.eighteen"
                class="error"
              >{{errors.eighteen}}</span> 18. életévemet betöltöttem</p>
          </label>
        </div>
        <input
          id="submission"
          type="submit"
          value="Eredmény"
        >
      </div>
    </form>
    <div class="thankyoupage">
      <div class="thanktitle">Kedves {{nev}}!</div>
      <div class="thanksubtext">Köszönjük, hogy kitöltötted a kvízt. Az értékelést a megadott e-mail címre küljdük.</div>
      <div class="btn">
        <a
          href="https://forbes.hu"
          title="forbes.hu"
        >Tovább a <img
            alt="Forbes"
            class="nxtforbes"
            src="../assets/images/forbes-head.svg"
          >.hu-ra</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import vueMask from 'vue-jquery-mask'

export default {
  name: 'Kform',
  components: {
    vueMask
  },
  data: function () {
    return {
      errors: {},
      nev: null,
      email: null,
      telefon: null,
      teloptions: {
        placeholder: 'telefon: 36-70-123-4567*'
      },
      beosztas: null,
      nyilatkozat: null,
      // jatekszabaly: null,
      eighteen: null,
      kerdesek: [
        // Networking
        {
          bevezeto: 'Networking - Networking alatt azt a vezetői viselkedést értjük, mely kiemelt figyelmet fordít a széleskörű üzleti és partneri kapcsolatok kiépítésére és azok gondozására.',
          kerdes: 'Élő kapcsolatokat ápolok saját iparágam piaci szereplőivel. Nyomon követem a saját iparágam piaci szereplőinek változásait.'
        },
        {
          kerdes: 'Igyekszem megismerni mások bevált vezetési gyakorlatait.'
        },
        {
          kerdes: 'Implementálom mások legjobb gyakorlatait.'
        },
        {
          kerdes: 'Naprakészen el tudom magam helyezni a piaci szegmensemben.'
        },
        {
          kerdes: 'Nem csak a saját iparágam vezetőivel tartom a kapcsolatot. Keresem a kapcsolódási pontokat más piaci területek vezetőivel.'
        },
        {
          kerdes: 'Úgy érzem, hogy más iparágak megoldásai, gyakorlatai kis átalakítással a saját területemen is hasznosak lehetnek. Törekszem rá, hogy ezeket innovatívan alkalmazzam a saját problémáim megoldására, a hatékonyság javítására.'
        },
        {
          bevezeto: 'Üzletorientáltság - Üzletorientáltságnak nevezzük azt, amikor a vezető döntéseit – akár üzleti-gazdasági, akár folyamatszabályozási, akár személyi kérdésekben – az eredményesség, a hatékonyság növelésének, a magasabb szintű teljesítmény elérésének szándéka döntő mértékben befolyásolja.',
          kerdes: 'Holisztikus szemlélet jellemez, távlatokban gondolkodom.'
        },
        {
          kerdes: 'Szakmai döntéseimet befolyásolja az üzleti eredményesség.'
        },
        {
          kerdes: 'Törekszem megismerni és átlátni a cégem teljes vertikumát. Nyomon követem a cégem teljes folyamatszabályozását.'
        },
        {
          kerdes: 'Kihívó, inspiráló célokat határozok meg.'
        },
        {
          kerdes: 'A lehető leggyorsabban reagálok a piaci változásokra.'
        },
        {
          kerdes: 'A piac alakítására törekszem.'
        },
        {
          bevezeto: 'Coaching - A coaching szemléletű vezetés központi gondolata, hogy a vezető segíti munkatársait annak megértésében, hogy merre tart a szervezet, valamint abban, hogy képessé váljanak – az üzleti irányvonalak ismeretében –, a pillanatnyi legjobb tudásuk szerint megtalálni a megoldásokat az aktuális kihívásokra.',
          kerdes: 'Törekszem megismerni beosztottjaim képességeit, készségeit (kompetenciáit).'
        },
        {
          kerdes: 'A kompetenciáknak megfelelően bízok feladatokat embereimre.'
        },
        {
          kerdes: 'Építek a beosztottaim önálló kezdeményezéseire.'
        },
        {
          kerdes: 'Figyelek a beosztottaim motivációjának fenntartására.'
        },
        {
          kerdes: 'Bevonom a döntésekbe a közvetlen beosztottaimat.'
        },
        {
          kerdes: 'Megosztok, vagy átadok hatásköröket a közvetlen beosztottaimnak.'
        }
      ],
      valaszok: {
        a: {
          text: 'soha nem teszek így'
        },
        b: {
          text: 'előfordul'
        },
        c: {
          text: 'többnyire igen'
        },
        d: {
          text: 'gyakran'
        },
        e: {
          text: 'mindig'
        }
      }
    }
  },
  methods: {
    thankYou () {
      document.querySelector('.thankyoupage').classList.add('show')
      document.querySelector('form').remove()
      this.$ga.page({
        title: 'Kitöltés köszönő',
        page: '/kviz',
        location: window.location.href
      })
    },
    checkForm () {
      this.errors = {}
      if (!this.nev) {
        this.errors.nev = 'Kérlek add meg a neved!'
      }
      if (!this.email) {
        this.errors.mail1 = 'Kérlek add meg az e-mail címed!'
      } else if (!this.validEmail(this.email)) {
        this.errors.mail2 = 'Kérlek valós e-mail címet adj meg!'
      }
      if (!this.telefon) {
        this.errors.telefon1 = 'Kérlek add meg a telefonszámod!'
      }
      if (this.telefon.length < 13 && this.telefon.length > 0) {
        this.errors.telefon2 = 'Kérlek valós telefonszámot adj meg!'
      }
      if (!this.beosztas) {
        this.errors.beosztas = 'Kérlek add meg a beosztásodat!'
      }
      if (!this.nyilatkozat) {
        this.errors.nyilatkozat = 'Kérlek fogadd el az adatvédelmi tájékoztatót!'
      }
      /* if (!this.jatekszabaly) {
        this.errors.jatekszabaly = 'Kérlek fogadd el a játékszabályzatot!'
      } */
      if (!this.eighteen) {
        this.errors.eighteen = 'Csak akkor vehetsz részt, ha elmúltál már 18 éves!'
      }
      if (this.nev && this.email && this.telefon && this.telefon.length >= 13 && this.beosztas && this.nyilatkozat /* && this.jatekszabaly */ && this.eighteen) {
        return true
      }
    },
    validEmail (email) {
      // eslint-disable-next-line
      var re = /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email)
    },
    formPost (event) {
      event.preventDefault()
      if (this.checkForm() === true) {
        const parentThis = this
        const form = document.querySelector('form')

        var fd = new FormData(form)
        var xhr = new XMLHttpRequest()
        xhr.open(
          'POST',
          'https://forbes.hu/extra/milyen-a-21.szazadi-vezeto/backend/process.php'
        )

        /* xhr.addEventListener('load', function (event) {
          console.log(event.target);
      }); */

        // eslint-disable-next-line
        xhr.addEventListener("error", function (event) {
          // console.log(Error);
          // console.log(event.target);
        })

        xhr.onreadystatechange = function () {
          if (this.readyState === 4 && this.status === 200) {
            // console.log(this.responseText);
            parentThis.thankYou()
          }
        }
        xhr.send(fd)
      }
    },
    ...mapActions([
      'decrement',
      'increment',
      'prevslide',
      'nextslide'
    ]),
    countQuestions () {
      this.$store.state.currentStep = 1
      this.$store.state.maxStep = this.kerdesek.length + 1
      this.stepBar()
      this.resetstep()
      document.querySelector('#kvizmvuk').reset()
    },
    moveBG () {
      const WindowWidth = document.querySelector('body').clientWidth
      const bgIMG = document.querySelector('.backgroundimg')
      const stepSize = (bgIMG.scrollWidth - WindowWidth) / this.$store.state.bgMax
      bgIMG.setAttribute('style', 'transform: translateX(' + (stepSize * this.$store.state.bgCurrent) * -1 + 'px)')
    },
    stepBar () {
      const barinner = document.querySelector('.barinner')
      barinner.style.cssText = `flex-basis: ${this.$store.state.currentStep / (this.$store.state.maxStep - 1) * 100}%`
    },
    stepBack () {
      this.$store.dispatch('decrement')
      this.$store.dispatch('prevslide')
      this.stepBar()
      this.moveBG()
    },
    stepNext () {
      this.$store.dispatch('increment')
      this.$store.dispatch('nextslide')
      this.stepBar()
      this.moveBG()
      window.scrollTo(0, 0)
      this.$ga.page({
        title: `Kviz oldal: ${this.$store.state.currentStep}`,
        page: '/kviz',
        location: window.location.href
      })
    },
    resetstep () {
      this.$store.state.currentStep = 1
      this.$store.state.bgCurrent = 2
      this.moveBG()
    },
    choice (e) {
      e.target.parentElement.classList.add('chosen')
      const siblings = e.target.parentElement.parentElement.querySelectorAll('.valasz')
      for (let index = 0; index < siblings.length; index++) {
        const element = siblings[index]
        if (!element.classList.contains('chosen')) {
          element.classList.add('not')
          element.querySelector('input').disabled = true
        }
      }
      /* Because of fucking IE
      siblings.forEach(element => {
        if (!element.classList.contains('chosen')) {
          element.classList.add('not')
          element.querySelector('input').disabled = true
        }
      }) */
      this.stepNext()
    }
  },
  mounted () {
    this.countQuestions()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.kerdesek {
  margin: 0 auto;
  width: calc(100vw - 100px);
}
.kbevezeto {
  margin: 0 auto 15px auto;
  font-size: 18px;
}
.kbevezeto,
.kerdes {
  width: 70vw;
}
.kerdes {
  margin: 0 auto 40px auto;
}
.kerdes,
.title,
.thanktitle {
  font-family: "Abril Fatface", cursive;
  font-size: 32px;
}
.thanksubtext {
  font-size: 18px;
}
.number {
  font-size: 50px;
}
.valaszcont {
  width: 100%;
  display: grid;
  grid-template-columns: 165px 165px 165px 165px 165px;
  grid-row-gap: 20px;
  grid-column-gap: 20px;
  justify-content: center;
}
.valasz label {
  display: flex;
  justify-content: center;
  border-radius: 22px;
  background-color: #fff;
  padding: 10px 14px;
  border: 2px solid #2ca6ac;
  font-size: 18px;
  font-weight: 700;
}
.valasz input[type="radio"] {
  display: none;
}
.valasz.chosen,
.valasz.not {
  pointer-events: none;
  cursor: default;
}
.valasz label:hover {
  cursor: pointer;
}
.valasz label:hover,
.valasz.chosen label {
  background-color: #abdbd8;
}
.valasz.not:hover label {
  background-color: #fff;
}
.valasz.not label {
  color: #666;
}
.last {
  display: grid;
  margin: 20px auto 0 auto;
  width: 65vw;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 20px;
}
.last a {
  color: #42475c;
}
.urlaphead,
.magyarazat,
.jogicont,
.errors,
#submission {
  grid-column: 1/3;
}
#submission {
  justify-self: center;
  border: none;
  padding: 15px 30px;
  font-size: 14px;
  margin-bottom: 20px;
}
.last input {
  border-radius: 22px;
  border: 2px solid #2ca6ac;
  padding: 10px 20px;
  font-size: 18px;
  font-family: "PT Sans Narrow", Arial, sans-serif;
}
.formfield input {
  width: stretch;
}
.last input:focus,
.last input:active {
  border: 2px solid #41465b;
  outline: none;
}
.jogicont {
  display: flex;
  flex-wrap: wrap;
  font-size: 16px;
}
.magyarazat {
  flex-basis: 100%;
  margin-bottom: 15px;
}
.jogicont input {
  flex-basis: 20px;
  transform: scale(1.5);
  margin: 4px 10px 0 0;
}
.jogicont label {
  flex-basis: calc(100% - 40px);
}
.jogicont p {
  margin-block-start: 5px;
  margin-block-end: 5px;
}
.error {
  color: red;
}
.formfield .error {
  margin-left: 20px;
}
.thankyoupage {
  display: none;
  color: #42475b;
}
.thankyoupage.show {
  display: block;
  max-width: calc(100vw - 60px);
  margin: 0 auto;
  text-align: center;
}
.thanktitle {
  margin: 60px 0 20px 0;
}
.thankyoupage .btn {
  margin: 40px auto 0 auto;
}
.thankyoupage .btn a {
  color: #fff;
  text-decoration: none;
}
.thankyoupage .btn a img {
  height: 18px;
}
@media screen and (max-width: 767px) {
  .kerdes {
    margin: 0 auto 20px auto;
  }
  .kerdes,
  .title,
  .thanktitle {
    font-size: 24px;
  }
  .number {
    font-size: 42px;
  }
  .kbevezeto {
    margin: 0 auto 10px auto;
  }
  .kbevezeto,
  .kerdes {
    width: 100%;
  }
  .kerdesek {
    width: calc(100vw - 60px);
  }
  .valaszcont {
    grid-template-columns: auto;
    margin-bottom: 20px;
  }
  .last {
    width: calc(100vw - 60px);
    grid-template-columns: auto;
  }
  .formfield {
    width: 100%;
  }
  .urlaphead,
  .magyarazat,
  .jogicont,
  .errors,
  #submission {
    grid-column: 1/2;
  }
  .jogicont {
    color: #000;
    font-weight: 700;
  }
  .jogicont a {
    color: #000;
  }
}
</style>
